import { Injectable, inject } from '@angular/core';
import { DashboardService } from '@eview/core/domain/dashboard/dashboard.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EDashboardActions, GetChartsData, GetChartsDataFailure, GetChartsDataSuccess, GetRegionData, GetRegionDataFailure, GetRegionDataSuccess } from '../actions/dashboard.actions';

@Injectable()
export class DashboardEffects {
  constructor(private dashboardService: DashboardService) {}

  private readonly actions$ = inject(Actions);

  getRegionData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetRegionData>(EDashboardActions.GetRegionData),
      switchMap(action =>
        this.dashboardService.getRegionData(action.payload).pipe(
          map(payload => (payload ? new GetRegionDataSuccess(payload) : new GetRegionDataFailure())),
          catchError(() => of(new GetRegionDataFailure()))
        )
      )
    )
  );

  getChartsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetChartsData>(EDashboardActions.GetChartsData),
      switchMap(action =>
        this.dashboardService.getChartsData(action.payload).pipe(
          map(payload => (payload ? new GetChartsDataSuccess(payload) : new GetChartsDataFailure())),
          catchError(() => of(new GetChartsDataFailure()))
        )
      )
    )
  );
}
